/*
 * @Description: 权限按钮
 * @Author: 李镇鹏
 * @Date: 2019-06-24 10:41:42
 * @LastEditTime: 2021-12-23 10:20:01
 * @LastEditors: zhao - 🍉
 */
import React,{ Component } from "react";
import { Button, Switch } from "antd";
import { connect } from 'react-redux';
import { adminAuthKey } from '../../axios/authKey';


const  checkAuth = (key, storeAuth = {}) =>{
    const {authKeyList,isAdmin,menusAuth } = storeAuth
    const adminAuth = adminAuthKey(menusAuth)


    if(!key) return false
    if(!authKeyList) return false
    if(isAdmin) {
        if( adminAuth.indexOf(key) > -1 ) return true
        if(Array.isArray(key)) return key.some(e=>adminAuth.indexOf(e) > -1)
    }

    if(!isAdmin && Array.isArray(key)) return key.some(e=> authKeyList.indexOf(e) > -1 )

    return authKeyList.indexOf(key) > -1
}
class AuthButton extends Component{
    
    render(){
        const access = checkAuth(this.props.authkey, this.props.config.auth)
        if(this.props.componentName === 'Switch'){
            return <Switch {...this.props.children.props} disabled={!access} />
        }
        if(!access){
            return null
        }
        if(typeof(this.props.children) === 'object' || this.props.ghost){
            return this.props.children
        }
        return <Button {...this.props}>{this.props.children}</Button>
    }
}
const mapStateToProps = state => {
    return state
};
export default connect(mapStateToProps)(AuthButton)


// WEBPACK FOOTER //
// ./src/components/AuthButton/AuthButton.jsx